<form autocomplete="off">
    <div *ngIf="Header" class="filter-options">{{Header}}</div>
    <pm-form-group *ngFor="let property of Request.Properties.Values" [Property]="property">
    </pm-form-group>
    <pm-form-group>        
        <ng-container *ngTemplateOutlet="ButtonTemplate || defaultButtonTemplate" ></ng-container>        
    </pm-form-group>
</form>
<div class="button-bar">
    <pm-button-icon ButtonClass="button-icon-overlay-small" (click)="ShowSettings()" *ngIf="DevMode">        
        <pm-icon-cogs></pm-icon-cogs>
    </pm-button-icon>
</div>

<ng-template #defaultButtonTemplate>
    <div class="layout-flex {{ButtonClass}}">
        <pm-button [IsDisabled]="IsBusy" (Click)="Submit()" ButtonClass="button-primary">
            <div>{{ButtonLabel}}</div>
        </pm-button>

        <pm-button [style.padding-left.px]="5" *ngIf="CanClear" [IsDisabled]="IsBusy" (Click)="Clear()" ButtonClass="button-standard">
            <div>{{ButtonClearLabel}}</div>
        </pm-button>

        <pm-button [style.padding-left.px]="5" *ngIf="CanCancel" [IsDisabled]="IsBusy == false" (Click)="Cancel()" ButtonClass="button-standard">
            <div>{{ButtonCancelLabel}}</div>
        </pm-button>
    </div>
</ng-template>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/form/form.html